/**
 * EmailLog Entity
 * Represents a log entry for a sent email
 */
export class EmailLog {
  constructor(
    public readonly id: number,
    public readonly recipientEmail: string,
    public readonly subject: string,
    public readonly templateId: string | null,
    public readonly status: EmailStatus,
    public readonly resendId: string | null,
    public readonly errorMessage: string | null,
    public readonly sentBy: string | null,
    public readonly workspaceId: number | null,
    public readonly metadata: Record<string, unknown>,
    public readonly createdAt: Date
  ) {}

  /**
   * Check if email was sent successfully
   */
  isSuccessful(): boolean {
    return this.status === 'sent';
  }

  /**
   * Check if email failed
   */
  isFailed(): boolean {
    return this.status === 'failed' || this.status === 'bounced';
  }

  /**
   * Check if email is pending
   */
  isPending(): boolean {
    return this.status === 'pending';
  }

  /**
   * Get status label in Spanish
   */
  getStatusLabel(): string {
    return EMAIL_STATUS_LABELS[this.status];
  }

  /**
   * Get status color for UI
   */
  getStatusColor(): string {
    return EMAIL_STATUS_COLORS[this.status];
  }
}

export type EmailStatus = 'sent' | 'failed' | 'pending' | 'bounced';

export const EMAIL_STATUS_LABELS: Record<EmailStatus, string> = {
  sent: 'Enviado',
  failed: 'Fallido',
  pending: 'Pendiente',
  bounced: 'Rebotado',
};

export const EMAIL_STATUS_COLORS: Record<EmailStatus, string> = {
  sent: 'green',
  failed: 'red',
  pending: 'amber',
  bounced: 'orange',
};

export const EMAIL_STATUSES: EmailStatus[] = ['sent', 'failed', 'pending', 'bounced'];
